import { clsx } from 'clsx'
import React, { FunctionComponent, useState } from 'react'
import { Input, InputProps, InputOnChange } from '../Input'
import { ClusterPosition } from '../Input/constants'
import { useThemeClass } from '../Theme'
import styles from './style.module.scss'

interface InputClusterResponse {
  [key: string]: string
}

export interface InputClusterProps {
  onChange?: (response: InputClusterResponse) => any
  Top: InputProps
  Middle?: InputProps
  Left: InputProps
  Right: InputProps
  testNameSpace?: string
}

export const InputCluster: FunctionComponent<InputClusterProps> = (props) => {
  const { Top, Middle, Left, Right, testNameSpace = '', onChange = () => {} } = props
  const [, setOnChangeResponse] = useState({})
  const hasTestId = testNameSpace.length > 0
  const themeClass = useThemeClass()
  const wrapperClass = clsx(styles.wrapper, styles[themeClass])

  const onInputChange = (clusterPosition: ClusterPosition) => (e: InputOnChange, rawValue: string, viewValue: string) => {
    props[clusterPosition]?.onChange?.(e, rawValue, viewValue)
    setOnChangeResponse((curr) => {
      const key = props[clusterPosition]?.name ?? clusterPosition
      const response = { ...curr, [key]: rawValue }
      onChange(response)
      return response
    })
  }

  return (
    <div className={wrapperClass} {...(hasTestId && { 'data-testid': `${testNameSpace}-inputCluster` })}>
      <Input {...Top} onChange={onInputChange(ClusterPosition.TOP)} clusterPosition={ClusterPosition.TOP} />
      {Middle !== undefined && (
        <div className={styles.middleWrapper}>
          <Input {...Middle} onChange={onInputChange(ClusterPosition.MIDDLE)} clusterPosition={ClusterPosition.MIDDLE} />
        </div>
      )}
      <div className={styles.inputBottomWrapper}>
        <Input {...Left} onChange={onInputChange(ClusterPosition.LEFT)} clusterPosition={ClusterPosition.LEFT} />
        <Input {...Right} onChange={onInputChange(ClusterPosition.RIGHT)} clusterPosition={ClusterPosition.RIGHT} />
      </div>
    </div>
  )
}
